import * as React from 'react';
import { ZERO_LEVEL_PADDING, REGULAR_PADDING } from './constants';
import { HierarchyMetadata } from './types';
import styles from './list-item-lines.scss';

export const renderLine = (
  hierarchyMetadata: HierarchyMetadata[],
  maxTreeDepthLevel: number,
  currentTreeDepthLevel: number = 0
) => {

  if (currentTreeDepthLevel <= maxTreeDepthLevel) {

    const codeItemHierarchyMetadata = hierarchyMetadata.find(metadata => metadata.depthLevel === currentTreeDepthLevel);

    const hasChildren = !!codeItemHierarchyMetadata ? codeItemHierarchyMetadata.hasChildren : undefined;

    const isLastChild = !!codeItemHierarchyMetadata ? codeItemHierarchyMetadata.isLastChild : undefined;

    const leftPosition = getLeftPosition(currentTreeDepthLevel, maxTreeDepthLevel);
    const shortLine = shouldRenderShortLine(currentTreeDepthLevel, maxTreeDepthLevel, isLastChild) ? styles.shortLine : '';
    const shouldHideLine = isLastChild && hasChildren;

    return <div className={`${styles.line} ${shortLine} ${shouldHideLine ? styles.hiddenLine : ''}`}
      style={{ left: `${leftPosition}px` }}>
      {shouldRenderHorizontalLine(currentTreeDepthLevel, maxTreeDepthLevel) &&
        <div className={styles.horizontalLine} style={{ bottom: '0px' }} />}
      {renderLine(hierarchyMetadata, maxTreeDepthLevel, currentTreeDepthLevel + 1)}
    </div>;
  }

  return null;
};

const shouldRenderShortLine = (treeDepthLevel?: number, maxTreeDepthLevel?: number, isLastChild?: boolean) => {
  return isLastChild && shouldRenderHorizontalLine(treeDepthLevel, maxTreeDepthLevel);
};

const shouldRenderHorizontalLine = (treeDepthLevel?: number, maxTreeDepthLevel?: number): boolean => {
  return treeDepthLevel === maxTreeDepthLevel && treeDepthLevel !== 0;
};

const getLeftPosition = (treeDepthLevel?: number, maxTreeDepthLevel?: number) => {
  if (treeDepthLevel === 0) {
    return ZERO_LEVEL_PADDING;
  }

  return REGULAR_PADDING;
};
